var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('header-component'),_vm._v(" "),_c('v-main',{staticClass:"mx-4",attrs:{"app":true}},[_vm._t("default")],2),_vm._v(" "),_c('footer-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }